const website = require('../configs/website.json')
const IMAGE_GEEKO_LTD = 'https://image.geeko.ltd'


module.exports = {
	IMAGE_GEEKO_LTD: website?.baseImageUrl || IMAGE_GEEKO_LTD
}